import React from 'react'
import { UpdateList } from './UpdateList'
import { UpdateItem } from './types'

interface Props {
  fetchLatestPostmarkUpdates(): Promise<UpdateItem[]>
}

interface State {
  loading: boolean
  error: boolean
  updates: UpdateItem[]
}

const LoadingError = () => (
  <div className='u-font-size-m u-pad-top-s'>
    <p>
      Oops! We couldn’t load the updates feed.
      <br />
      Check out
      {' ' /* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href='https://postmarkapp.com/blog' target='_blank'>
        our blog
      </a>{' '}
      for product news.
    </p>
  </div>
)

export class LatestUpdates extends React.Component<Props, State> {
  public state: State = {
    loading: true,
    error: false,
    updates: [],
  }

  public componentDidMount() {
    const { fetchLatestPostmarkUpdates } = this.props

    this.setState({ loading: true, error: false })

    fetchLatestPostmarkUpdates()
      .then(updates => {
        this.setState({
          loading: false,
          updates: updates.slice(0, 3),
        })
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: true,
        })
      })
  }

  public render() {
    const { loading, error, updates } = this.state

    if (!loading && error) {
      return <LoadingError />
    }

    return loading ? (
      <div className='u-relative u-pad-top-l'>
        <div className='u-is-loading' />
      </div>
    ) : (
      <UpdateList updates={updates} />
    )
  }
}
